export default __webpack_public_path__ + "static/media/BSCDEFI.718126a6.svg";